import React from 'react';
import styled, { css } from 'styled-components';
import { mq } from '../../../../../common/src/utils/styledComponentsUtils';

interface Props {
  title: string;
  description?: string;
  fontSize?: string;
  maxWidth?: string;
  hideTitleMobile?: boolean;
}

const AssistantText: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  description,
  fontSize,
  maxWidth,
  hideTitleMobile,
  ...otherProps
}) => {
  return (
    <Wrapper maxWidth={maxWidth} {...otherProps}>
      <Title fontSize={fontSize} hideTitleMobile={hideTitleMobile}>
        {title}
      </Title>
      {description && (
        <Description
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      )}
    </Wrapper>
  );
};

const Description = styled.p`
  color: ${({ theme }) => theme.gray[400]};
  font-size: 1.4rem;
  line-height: 120%;
  margin-top: 1.6rem;

  > span {
    color: ${({ theme }) => theme.primary[500]};
  }

  ${mq.laptop} {
    font-size: 1.6rem;
  }
`;

const Title = styled.h1<{ fontSize?: string; hideTitleMobile?: boolean }>`
  font-size: 2.2rem;
  line-height: 120%;
  font-weight: 700;
  color: ${({ theme }) => theme.typo.title};

  ${mq.laptop} {
    margin-top: 1.2rem;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '4.2rem')};
  }

  ${({ hideTitleMobile }) =>
    hideTitleMobile &&
    css`
      display: none;

      ${mq.laptop} {
        display: block;
      }
    `}
`;

const Wrapper = styled.div<{ maxWidth?: string }>`
  max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : '68rem')};
  margin-bottom: 1.6rem;
`;

export default AssistantText;
